import { Component, forwardRef, Input, AfterViewInit, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FloatLabelType } from '@angular/material/form-field';
import { MatSelectChange } from '@angular/material/select';

import { CdwSelectOption } from '@cdw-ae/shared-interfaces';


@Component({
  selector: 'lib-cdw-select',
  templateUrl: './cdw-select.component.html',
  styleUrls: ['./cdw-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CdwSelectComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class CdwSelectComponent implements ControlValueAccessor, AfterViewInit {
  @Input() label = '';

  @Input() placeholder = '';

  @Input() public values: CdwSelectOption[] = [];

  @Input() disabled = false;

  @Input() multiSelect = false;

  @Input() hideRequiredMarker = false;

  @Input() floatLabel!: FloatLabelType;

  @Input() customTrigger = '';

  @Input() inputWidth = '';

  @Input() panelWidth = '';

  selected: unknown = undefined;

  private panelStyleId = `cdw-panel-${Math.random().toString(36).substring(2, 11)}`;

  constructor(private renderer: Renderer2) {}

  onChange = (value: unknown) => {
    // Default implementation - will be overridden by registerOnChange
  };

  onTouched = () => {
    // Default implementation - will be overridden by registerOnTouched
  };

  ngAfterViewInit(): void {
    if (this.panelWidth) {
      const style = this.renderer.createElement('style');
      const styleContent = this.renderer.createText(`
        .${this.panelStyleId}.mat-mdc-select-panel {
          width: ${this.panelWidth} !important;
          min-width: ${this.panelWidth} !important;
          max-width: ${this.panelWidth} !important;
        }
      `);
      this.renderer.appendChild(style, styleContent);
      this.renderer.appendChild(document.head, style);
    }
  }

  registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  writeValue(value: unknown) {
    this.selected = value;
  }

  onSelectChanged($event: MatSelectChange) {
    this.onChange($event.value);
    this.onTouched();
  }

  get panelClass(): string {
    return this.panelWidth ? this.panelStyleId : '';
  }
}
